import { matchPath } from 'react-router-dom';
import { isFunction, removeTrailingSlash } from '../../../utils';
/*
 * @param {String} [url] a url to match against routeTrails.
 * @param {Object} [context] a object holding context to enable title creation
 * @param {RouteTrail[]} [routeTrails] define breadcrumbs based on route paths.
 *
 * @return {breadCrumb} Holding information to render a clickable item or link.
 */
function createBreadCrumb(url, context, routeTrails) {
  const breadCrumb = routeTrails
    .map((trailDefinition) => {
      const match = matchPath(url, {
        path: trailDefinition.route,
        exact: true,
        strict: false,
      });

      return {
        ...trailDefinition,
        match,
        title:
          match && isFunction(trailDefinition.title)
            ? trailDefinition.title(context, match)
            : trailDefinition.title,
      };
    })
    .find((c) => c.match);
  return breadCrumb;
}

function routeTrail({ context, routeTrails, url }) {
  let currentUrl = '';

  return (
    url
      .split('/')
      .map((urlPart) => {
        if (urlPart) {
          currentUrl = `${currentUrl}/${urlPart}`;
        }
        return currentUrl;
      })
      .map((currentUrl_) => createBreadCrumb(currentUrl_, context, routeTrails))
      .filter(Boolean) || []
  );
}

function getNewUrl({ activeTree, url }) {
  let newUrl = removeTrailingSlash(url).replaceAll(/\/pages\/\d*.*/gm, '');
  if (activeTree?.page >= 0) {
    newUrl = `${newUrl}/pages/${activeTree.page}`;
  }
  if (activeTree?.section >= 0) {
    newUrl = `${newUrl}/sections/${activeTree.section}`;
  }
  if (activeTree?.column >= 0) {
    newUrl = `${newUrl}/columns/${activeTree.column}`;
  }
  if (activeTree?.panel >= 0) {
    newUrl = `${newUrl}/panels/${activeTree.panel}`;
  }
  return newUrl;
}

export { createBreadCrumb, routeTrail, getNewUrl };
